export const GET_NOTE_DETAIL_SUCCESS = 'GET_NOTE_DETAIL_SUCCESS';
export const UPDATE_NOTE_DETAIL_SUCCESS = 'UPDATE_NOTE_DETAIL_SUCCESS';
export const ADD_VIDEO_TO_FAVORITE_LIST = 'ADD_VIDEO_TO_FAVORITE_LIST';
export const GET_NOTES_DOWNLOAD_ADDRESS_SUCCESS = 'GET_NOTES_DOWNLOAD_ADDRESS_SUCCESS';
export const LOADING_MESSAGE = '正在为您加载课程笔记信息...';
export const SET_READING_IDX = 'SET_READING_IDX';
export const SET_BULLET_IDX = 'SET_BULLET_IDX';
export const SET_NOTE_IDX = 'SET_NOTE_IDX';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const BLANK_V_NOTE = {
  isDummy: true,
  bullet: {},
};
